import { setupSGWTConnect } from '@sgwt/connect-core';

import { appConfig, isUnderSgConnectMock } from 'app/app.config';

const sgConnectConfig = structuredClone(appConfig.sgconnect);

if (isUnderSgConnectMock) {
  const user = new URL(window.location.href).searchParams.get('navigateAsUserId');
  if (user) {
    console.info('Overriding SG Connect client_id with user from URL:', user);
    sgConnectConfig.client_id = user;
    sgConnectConfig.redirect_uri = `${sgConnectConfig.redirect_uri}?navigateAsUserId=${user}`;
  }
}

export const sgwtConnect = setupSGWTConnect(sgConnectConfig);
